import { combineReducers } from 'redux';
import { mypageReducer } from './mypageReducer';
import { userReducer } from './userReducer';
import { mysearchReducer } from './mysearchReducer';
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
    key: "root",
    // localStorage에 저장합니다.
    storage,
    // auth, board, studio 3개의 reducer 중에 auth reducer만 localstorage에 저장합니다.
    whitelist: ["user", "mypage", "mysearch"]
    // blacklist -> 그것만 제외합니다
};

const rootReducer = combineReducers({

    user: userReducer,
    mypage: mypageReducer,
    mysearch: mysearchReducer

})

export const persistedReducer = persistReducer(persistConfig, rootReducer);